import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { Document } from '../../leads/document/document';
import { MODULE_SEQ } from '../../../core/shared/models/picklist.model';
import { CraditService } from '../shared/services/cradit.service';
import {
  CREDIT_PROPOSAL_ATTACHMENT_DOC_SEQS,
  CREDIT_PROPOSAL_DOCUMENT_DOC_SEQS,
} from '../shared/models/credit-proposal-documents.constants';

type DocumentsTab = 'document' | 'attachments';

/**
 * Last Document Builder tab ("Documents") of the Credit Proposal, split into
 * two tabs that both reuse the shared document component (as leads,
 * onboarding and the facility offer letter do) with entity type 12, so
 * uploads are saved with entyTyp 12 and entySeq = crdtPrpslSeq:
 *  - Document:    document types 43 (Organogram), 42, 46 and 50;
 *  - Attachments: only document types 41, 44, 45 and 47.
 * Any file type can be uploaded on either tab.
 */
@Component({
  selector: 'app-credit-proposal-documents',
  standalone: true,
  imports: [NgClass, TranslatePipe, Document],
  templateUrl: './credit-proposal-documents.html',
  styleUrl: './credit-proposal-documents.css',
})
export class CreditProposalDocuments {
  @Input() crdtPrpslSeq: number | null = null;
  @Input() sectionId = '';
  @Input() editable = false;

  readonly CREDIT_PROPOSAL_MODULE_SEQ = MODULE_SEQ.CREDIT_PROPOSAL;

  /** Document types (docSeq) each tab can upload and lists. */
  readonly DOCUMENT_TAB_DOC_SEQS = [...CREDIT_PROPOSAL_DOCUMENT_DOC_SEQS];
  readonly ATTACHMENTS_TAB_DOC_SEQS = [...CREDIT_PROPOSAL_ATTACHMENT_DOC_SEQS];

  /** No file picker filter: any file type can be uploaded on these tabs. */
  readonly ANY_FILE_ACCEPT = '';

  activeTab: DocumentsTab = 'document';

  constructor(private readonly creditService: CraditService) {}

  /** Lets the Document Builder re-check whether this tab is complete. */
  onDocumentsChange(): void {
    this.creditService.documentsChanged$.next();
  }

  setTab(tab: DocumentsTab): void {
    this.activeTab = tab;
  }
}
